<template>
    <div>
        <div class="w" id="content">
            <div class="s_tl">
                当前位置：<a href="/">首页</a>
                <em class="lr3">&#62;</em>
                <a href="/help">帮助中心</a>
                <em class="lr3">&#62;</em>
                <a href="">新手上路</a>
                <em class="lr3">&#62;</em>
                <a href="">忘记密码，如何找回？</a>
            </div>
            <div class="ubg">
                <left-side></left-side>
                <!--left over-->
                <div class="u_r">
                    <div class="ah1 alC yahei">
                        <h1 class="f18">忘记密码，如何找回？</h1>
                        <p class="c9">发布时间：2022-01-04</p>
                    </div>
                    <div class="ainfo ov yahei">
                        <p class="font24">
                            一.进入会员登录页面（<a href="/user.php">点击直接进入</a>）
                        </p>
                        <p><br><img alt="" width="400" height="300" src="https://s.cccgx.com/images/article/20160725100127_87186.jpeg"></p>
                        <p style="font-size: 16px;">进入登录中心并点击忘记密码</p>
                        <p><br></p>
                        <p class="font24">二.输入会员手机号或邮箱</p>
                        <p>
                            <img alt="" width="668" height="249" src="https://s.cccgx.com/images/20140619/20140619142843_56544.png">
                        </p>
                        <p><br><br></p>
                        <p class="font24">三.输入手机或邮箱收到的验证码</p>
                        <p>
                            <img src="https://s.cccgx.com/images/20140619/20140619142953_76059.jpg" alt="" width="694" height="224">
                        </p>
                        <p><br><br></p>
                        <p class="font24">四.验证通过后设置新密码，密码找回完成</p>
                        <p>
                            <img src="https://s.cccgx.com/images/20140619/20140619143126_99608.png" alt="" width="656" height="229">
                        </p>
                        <p><br></p>
                    </div>
                    <!--info over-->
                    <p class="lh30"></p>
                    <p class="bline" style="padding: 30px 0px 0 0;"></p>
                    <p class="lh30"></p>
                    <p style="font-size:16px;">
                        <a href="/help/dingdan" style="float:left;">上一篇:如何查看/修改订单</a>
                        <a href="/help/youuhijuan" class="pl10" style="float:right">下一篇:夜樱情趣商城优惠劵使用说明</a>
                    </p>
                </div>
                <!--right over-->
                <div class="clear"></div>
            </div>
        </div>
    </div>
</template>

<script>
import Left_side from "@/components/help/left-side"
export default {
    components:{
        'left-side': Left_side
    },
}
</script>

<style scoped>
.ainfo {line-height: 32px;padding-top: 10px;font-size: 14px;}
.font24{font-size: 24px; color: rgb(229, 51, 51);}
.ubg{border:1px solid #e5e5e5;background-color:#fff;overflow:hidden;}
.u_l{width:170px;padding:10px;background:#fff;border-right:1px solid #e5e5e5;}
.u_r{padding:10px 40px 30px 40px;border-left:1px solid #e5e5e5;line-height:25px;background:#fff;margin-left:190px;min-height:600px;overflow: hidden;}
.dsl{display:inline;font-weight:normal;}
.udl{margin:0 5px 15px 5px;}
.udl dt{border-bottom:1px solid #e5e5e5;line-height:40px;display:block;font-size:14px;color:#333;font-weight:bold;margin-bottom:10px;}
.udl dd{line-height:30px;text-indent:15px;}
.udl a{display:block;color:#777;margin-bottom:1px;}
.udl a:hover,.udl a.on{color:#c40000;text-decoration:none; background-color:#e5e1e1;}
.article{width:100%;}
.article li{border-bottom:1px dashed #ddd;display:block;width:100%;font-size:14px;line-height:45px;}
.article a{display:block;width:100%;overflow:hidden;}
.article a:hover{color:#c40000;}
.ah1{color:#333;line-height:30px;padding-bottom:10px;border-bottom:2px solid #ddd;}
.a_goods a{width:220px;height:280px;display:inline;float:left;margin:10px 6px;line-height:18px;white-space:nowrap;overflow:hidden;}
</style>


// WEBPACK FOOTER //
// src/components/help/forgetpassword.vue